import styled from "@emotion/styled";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { GroupA, TitleA } from "@src/ruix";
import { BackTitleAProps } from "@src/ruix/types";

const BackTitleA = (props: BackTitleAProps) => {
	const { title, onClick } = props;

	return (
		<GroupA order="row-center-start" gap={0}>
			<BackTitleAComponent onClick={onClick} />
			<TitleA title={title} color="var(--card-bg)"></TitleA>
		</GroupA>
	);
};

const BackTitleAComponent = styled(ArrowBackIosIcon)`
	fill: var(--card-bg);
	cursor: pointer;
	font-size: 28px;

	&:hover {
		fill: var(--primary);
	}
`;

export default BackTitleA;
